import { invalidateItemCache } from '../layout/layout.actions';
import { getUid } from '../user/user.selectors';
import { removeBookmark as sendRemoveBookmarkRequest, addBookmark as sendAddBookmarkRequest } from './bookmark.utils';

export const invalidateCachedBookmarkState = bookmark => dispatch => {
  const { blockIndex, itemIndex, state: currentBookmarkState } = bookmark;

  dispatch(
    invalidateItemCache(itemIndex, blockIndex, {
      bookmark: {
        state: !currentBookmarkState,
      },
    }),
  );
};

export const addBookmark = bookmark => (dispatch, getState) => {
  dispatch(invalidateCachedBookmarkState(bookmark));

  return sendAddBookmarkRequest(bookmark, getUid(getState()));
};

export const removeBookmark = bookmark => (dispatch, getState) => {
  dispatch(invalidateCachedBookmarkState(bookmark));

  return sendRemoveBookmarkRequest(bookmark, getUid(getState()));
};
